import axios from 'axios'
import router from '../router'

import { Message } from 'element-ui'

const service = axios.create({
  baseURL: '/',
  timeout: 30000 // 设置请求超时时间
})
// let loading = "";
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在请求发送之前做一些处理
    if (!(config.headers['Content-Type'])) {
      if (config.method === 'post') {
        config.headers['Content-Type'] =
     'application/json;charset=UTF-8'
        for (var key in config.data) {
          if (config.data[key] === '') {
            delete config.data[key]
          }
        }
        config.data = JSON.stringify(config.data)
      } else {
        config.headers['Content-Type'] =
     'application/x-www-form-urlencoded;charset=UTF-8'
        config.data = JSON.stringify(config.data)
      }
    }
    const authorization = localStorage.getItem('authorization')
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    if (authorization) {
      config.headers.Authorization = authorization
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const dataAxios = response.data
    
    // 打印特定接口的响应
    if (response.config.url && response.config.url.includes('/api/Nebula/keywordsListAll')) {
      console.log('=== /api/Nebula/keywordsListAll 接口响应 ===')
      console.log('请求URL:', response.config.url)
      console.log('响应数据:', dataAxios)
      console.log('完整响应对象:', response)
      console.log('=======================================')
    }
    
    return dataAxios
  },
  (error) => {
    return Promise.reject(error)
  }
)

const request = (url, params, method = 'post') => {
  // const memberId = JSON.parse(localStorage.getItem('userinfo'))?.userid
  const data = {
    ...params
  }
  const axiosConfig = {
    url: url,
    method: method
  }

  // 根据请求方法添加 params 或 data
  if (method.toLowerCase() === 'get') {
    axiosConfig.params = data
  } else if (method.toLowerCase() === 'post') {
    axiosConfig.data = data
  }
  return new Promise((resolve, reject) => {
    // withCredentials
    // service.defaults.withCredentials = true
    service(axiosConfig).then((result) => {
      // 登录过期
      if (result.code === 1003) {
        // 检查当前路由是否不需要登录验证
        const currentRoute = router.currentRoute
        const requiresAuth = currentRoute.matched.some(record => record.meta.requiresAuth !== false)
        
        if (requiresAuth) {
          Message({
            message: '登录过期，请重新登录',
            type: 'error'
          })
          localStorage.removeItem('userinfo')
          localStorage.removeItem('authorization')
          router.push({ path: '/login' })
        } else {
          // 对于不需要登录的页面，不显示错误消息，不跳转登录页面
          console.warn('API需要登录，但当前页面不要求登录验证')
        }
      }
      if (result.code === 200) {
        resolve(result.result)
      } else {
        reject(result)
      }
    }).catch((err) => {
      reject(err)
    })
  })
}

export default request
